import { useMemo } from "react";

import { eachDayOfInterval, endOfWeek, format, startOfWeek } from "date-fns";

import { CalendarSettings } from "../types";

const FORMAT = "EEEEE";

export const useDayLabels = ({
  weekStartsOn,
  locale,
}: CalendarSettings): string[] => {
  const dayLabels = useMemo(() => {
    const startDay = startOfWeek(new Date(), { weekStartsOn });
    return eachDayOfInterval({
      start: startDay,
      end: endOfWeek(startDay, { weekStartsOn }),
    }).map((d) => format(d, FORMAT, { locale }));
  }, [weekStartsOn, locale]);

  return dayLabels;
};
